import { API_URL } from "./domain";
import { ApiClientBase } from "./api-client-base";
import { API_NAME } from "../constants";

export class AuthClient extends ApiClientBase {
  // ログイン関数
  async login(email: string, password: string): Promise<string> {
    try {
      const response = await fetch(`${API_URL}/${API_NAME}/login`, {
        method: "POST",
        headers: {
            ...await this.getHeaders(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.error || "Login failed.");
      }

      const data = await response.json();
      if (data && data.token) {
        return data.token;
      } else {
        throw new Error("Token not received.");
      }
    } catch (error) {
      console.error("Error in login:", error);
      throw error;
    }
  }

  // トークン検証関数
  async valid(): Promise<{ valid: boolean; tokenData?: object; error?: string }> {
    try {
      const response = await fetch(`${API_URL}/${API_NAME}/valid`, {
        method: "POST",
        headers: {
            ...await this.getHeaders(),
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      if (!response.ok) {
        return {
          valid: false,
          error: data.error || "Token validation failed.",
        };
      }

      return {
        valid: true,
        tokenData: data.tokenData,
      };
    } catch (error) {
      console.error("Error in token validation:", error);
      return {
        valid: false,
        error: "An error occurred during token validation.",
      };
    }
  }
}